import { jsxs, jsx } from 'react/jsx-runtime';
import 'luxon';
import '../../client-components/ThemeProvider.js';
import 'react';
import '../../client-components/Tabs/Tabs.module.scss.js';
import 'classnames';
import '../Table/components/HeaderCell.module.scss.js';
import Flex from '../layout/Flex/Flex.js';
import '../layout/Row/Row.module.scss.js';
import '../layout/Stack/Stack.js';
import '../layout/Box/Box.js';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../Table/Table.module.scss.js';
import '../Table/components/TableRow.module.scss.js';
import '../Table/components/Pagination.module.scss.js';
import '../Text/Text.js';
import '../Table/components/TableCell/TableCell.module.scss.js';
import '../Card/Card.module.scss.js';
import '../List/List.module.scss.js';
import '../ErrorBox/ErrorBox.module.scss.js';
import '../InfoBox/InfoBox.module.scss.js';
import '../KpiCard/KpiCard.module.scss.js';
import '../TrendValue/TrendValue.module.scss.js';
import '../Modal/Modal.module.scss.js';
import '../Badge/Badge.module.scss.js';
import '../HeatmapActivity/HeatmapActivity.module.scss.js';
import '../../client-components/Tooltip/Tooltip.js';
import '../Switch/Switch.module.scss.js';
import '@blockanalitica/ui';
import '../Select/Select.module.scss.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';
import 'react-loading-skeleton';
import ColumnsLoader from './ColumnsLoader.js';
import '../../client-components/ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../../client-components/ExpandableCard/ExpandableCard.module.scss.js';
import '../../client-components/ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../../client-components/CopyButton/CopyButton.module.scss.js';
import 'ethereum-blockies-base64';
import '../../client-components/WalletAddress/WalletAddress.module.scss.js';
import '../../client-components/filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../../client-components/sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../../client-components/FormattedCurrency/FormattedCurrency.js';
import '../../client-components/FormattedPercentage/FormattedPercentage.js';
import '../../client-components/CurrencyValue/CurrencyValue.module.scss.js';
import '../../client-components/PercentageValue/PercentageValue.module.scss.js';
import '../../client-components/DisplaySwitch/DisplaySwitch.module.scss.js';
import 'lodash';
import '../../client-components/charts/ChartJS.js';
import '../../client-components/charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../../client-components/charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../../client-components/charts/BarChart/BarChart.module.scss.js';
import '../../client-components/charts/LineChart/LineChart.module.scss.js';
import '../../client-components/charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../../client-components/Checkbox/Checkbox.module.scss.js';

function TableLoader() {
    return (jsxs(Flex, { gap: "space-xs", direction: "column", children: [jsx(ColumnsLoader, { elements: 3, columnHeight: "2rem" }), jsx(ColumnsLoader, { elements: 3, columnHeight: "2rem" }), jsx(ColumnsLoader, { elements: 3, columnHeight: "2rem" })] }));
}

export { TableLoader as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFibGVMb2FkZXIuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NlcnZlci1jb21wb25lbnRzL2xvYWRlcnMvVGFibGVMb2FkZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbHVtbnNMb2FkZXIsIEZsZXggfSBmcm9tICcuLi8uLi8uLic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFRhYmxlTG9hZGVyKCkge1xuICByZXR1cm4gKFxuICAgIDxGbGV4IGdhcD1cInNwYWNlLXhzXCIgZGlyZWN0aW9uPVwiY29sdW1uXCI+XG4gICAgICA8Q29sdW1uc0xvYWRlciBlbGVtZW50cz17M30gY29sdW1uSGVpZ2h0PVwiMnJlbVwiIC8+XG4gICAgICA8Q29sdW1uc0xvYWRlciBlbGVtZW50cz17M30gY29sdW1uSGVpZ2h0PVwiMnJlbVwiIC8+XG4gICAgICA8Q29sdW1uc0xvYWRlciBlbGVtZW50cz17M30gY29sdW1uSGVpZ2h0PVwiMnJlbVwiIC8+XG4gICAgPC9GbGV4PlxuICApO1xufVxuIl0sIm5hbWVzIjpbIl9qc3hzIiwiX2pzeCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBRWMsU0FBVSxXQUFXLEdBQUE7SUFDakMsUUFDRUEsS0FBQyxJQUFJLEVBQUEsRUFBQyxHQUFHLEVBQUMsVUFBVSxFQUFDLFNBQVMsRUFBQyxRQUFRLGFBQ3JDQyxHQUFDLENBQUEsYUFBYSxJQUFDLFFBQVEsRUFBRSxDQUFDLEVBQUUsWUFBWSxFQUFDLE1BQU0sRUFBRyxDQUFBLEVBQ2xEQSxJQUFDLGFBQWEsRUFBQSxFQUFDLFFBQVEsRUFBRSxDQUFDLEVBQUUsWUFBWSxFQUFDLE1BQU0sRUFBQSxDQUFHLEVBQ2xEQSxHQUFBLENBQUMsYUFBYSxFQUFDLEVBQUEsUUFBUSxFQUFFLENBQUMsRUFBRSxZQUFZLEVBQUMsTUFBTSxFQUFBLENBQUcsQ0FDN0MsRUFBQSxDQUFBLEVBQ1A7QUFDSjs7OzsifQ==
